"use client";

import { useEffect } from "react";

/**
 * dev overlay 숨김 컴포넌트
 * dev_overlay 쿠키가 없으면 Next.js 에러 오버레이를 CSS로 숨김
 */
export function DevOverlayGuard() {
  useEffect(() => {
    const hasDevCookie = document.cookie
      .split(";")
      .some((c) => c.trim().startsWith("dev_overlay="));

    if (!hasDevCookie) {
      const style = document.createElement("style");
      style.id = "hide-dev-overlay";
      style.textContent = `
        nextjs-portal,
        [data-nextjs-dialog-overlay],
        [data-nextjs-toast],
        #__next-build-indicator,
        [data-nextjs-scroll] {
          display: none !important;
        }
      `;
      document.head.appendChild(style);
    }

    return () => {
      document.getElementById("hide-dev-overlay")?.remove();
    };
  }, []);

  return null;
}
